import { externalApiClient } from '@/shared/lib/apiClient';

export interface ServiceRegion {
  id: string;
  name?: string;
  codePath?: string[];
  superRegionId?: string;
  code?: string;
  depth?: number;
  legalRegions?: string[];
  [key: string]: any; // 다른 필드들도 있을 수 있음
}

export interface ServiceRegionSearchResult {
  id: string;
  code?: string;
  codePath?: string[];
  depth?: number;
  [key: string]: any;
}

/**
 * 서비스 구역 검색 (v2, 계층 검색 지원)
 * @param version API 버전 (필수)
 * @param code 지역 코드 (선택, 있으면 codePath prefix 계층 검색)
 */
export async function searchServiceRegions(
  version: number,
  code?: string
): Promise<ServiceRegionSearchResult[]> {
  const response = await externalApiClient.get<
    ServiceRegionSearchResult[] | { data: ServiceRegionSearchResult[] }
  >('/api/v2/service-regions/search', {
    headers: { 'Content-Type': 'application/json' },
    params: { version, ...(code && { code }) },
  });
  const raw = response.data;
  const arr = Array.isArray(raw) ? raw : (raw as { data?: ServiceRegionSearchResult[] })?.data;
  return Array.isArray(arr) ? arr : [];
}

/**
 * 서비스 구역 개별 조회 API (raw)
 * API 레이어: 순수 HTTP 호출만 수행. 캐시 없음.
 * @internal 클라이언트 레이어에서 사용
 */
export async function fetchServiceRegionById(id: string): Promise<ServiceRegion> {
  const response = await externalApiClient.get<ServiceRegion>(`/api/v1/service-regions/${id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}
